import type {
  IDemo,
  Play,
  Playbook,
  Tour,
  Workspace,
  WorkspaceFolder,
} from '@carboncopyco/types';
import constate from 'constate';

export type PlaybookPageProps = {
  rootPath: string;
  onGoBack: () => void;
  organizationId: string;
  playbookId: string;
  goToPlaybookPreview?: (play?: Play) => Promise<void>;
  workspaceId: string;
  goToPlaybookPage: (playbookId: Playbook['id']) => void;
  playPresentation?: (play: Play) => Promise<void>;
  desktopDomain?: string;
  goToWorkspacePage?: (workspaceId: Workspace['id']) => void;
  goToFolderPage?: (
    folderId: WorkspaceFolder['id'],
    workspaceId: Workspace['id']
  ) => void;
  tourPageLink: (tourId: Tour['id']) => string;
  demoPageLink: (demoId: IDemo['id']) => string;
  readOnly?: boolean;
};

const usePlaybookPage = (props: PlaybookPageProps): PlaybookPageProps => props;

export const [PlaybookPageProvider, usePlaybookPageProps] =
  constate(usePlaybookPage);
